// extracted by mini-css-extract-plugin
module.exports = {"breadcumbsList":"breadcrumbs_breadcumbsList__JqsH_","link":"breadcrumbs_link__oeXTz","backLink":"breadcrumbs_backLink__h8BdA"};